import React, { useMemo } from 'react'
import { Badge, RecordList } from '../BusinessDetailReport/BusinessDetailReport'
import styles from '../BusinessDetailReport/BusinessDetailReport.module.scss'
import { buildProperty } from './propertyModel'

const plural = (n, one, many = `${one}s`) => `${n} ${n === 1 ? one : many}`

export default function Property({ person, showSummary = true }) {
    const model = useMemo(() => buildProperty(person), [person])
    if (!model.hasData) return <div className={styles.calmLine}>No property records, foreclosures or default notices found.</div>
    const { summary } = model
    return (
        <div className={styles.uccList}>
            {showSummary && (
                <div className={styles.inlineBadges}>
                    {summary.properties > 0 && (
                        <Badge tone='neutral'>{plural(summary.properties, 'property', 'properties')}{summary.value ? ` · $${summary.value.toLocaleString('en-US')} total value` : ''}</Badge>
                    )}
                    {summary.distress > 0 && (
                        <Badge tone={summary.recent ? 'declined' : 'watch'} dot={summary.recent > 0}>{plural(summary.distress, 'foreclosure or default notice', 'foreclosures or default notices')}</Badge>
                    )}
                </div>
            )}
            {model.properties.length > 0 && <RecordList items={model.properties} />}
            {model.distress.length > 0 && (
                <>
                    <div className={styles.uccGroupTitle}>Foreclosures and default notices</div>
                    <RecordList items={model.distress} />
                </>
            )}
        </div>
    )
}
